export const TAG_PREFIX = 'xxya_cdoc_';
